<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body form-left p-l-10 p-r-10-p">
            <br>
            <div class="form-control b-0 p-0">訂單明細</div>
            <div class="order-list-box m-x-0">
              <div v-for="(p, index) in productList">
                <h4>{{index + 1}}. {{p.product}}</h4>
                <p><span v-for="option in p.option_list">{{option}} / </span> {{p.total_money}}元 / {{p.amount}}杯</p>
                <hr v-if="productList.length !== index + 1">
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  data () {
    return {
      productList: []
    }
  },
  methods: {
    getOrderInfo () {
      var self = this
      const orderId = this.$route.params.order_id
      var url = '/history/orderBriefHistory/' + orderId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.productList = response.data.product_list
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  created () {
    this.getOrderInfo()
  }
}
</script>



// WEBPACK FOOTER //
// HistoryOrderInfo.vue?7c014714